<template>
	<div class="modal-card addUser">
		<div class="modal-card-head">
			<p class="modal-card-title">Preview Opportunity</p>
		</div>
		<div class="modal-card-body">
			<div id="opportunityModal" class="columns">
				<div class="column">
					<div class="breathe-sm">
						<b>Title</b>
						<p>{{ Opp.Title }}</p>
					</div>
					<div class="breathe-sm">
						<b>Company</b>
						<p>{{ Opp.Company }}</p>
					</div>
					<div class="breathe-sm">
						<b>Firm</b>
						<p>{{ Opp.Firm }}</p>
					</div>
					<div class="breathe-sm">
						<b>Link</b>
						<br />
						<a class="button is-secondary" :href="Opp.Link">Send Mail</a>
					</div>
					<div class="breathe-sm">
						<b>Functions</b>
						<p v-for="x in Opp.FunctionsSelect">{{ x }}</p>
					</div>
					<div class="breathe-sm">
						<b>Industries</b>
						<p v-for="x in Opp.IndustriesSelect">{{ x }}</p>
					</div>
				</div>
				<div class="column">
					<div class="breathe-sm">
						<b>Job posted date</b>
						<p>{{ Opp.PostDate | moment("MM/DD/YYYY") }}</p>
					</div>
					<div class="breathe-sm">
						<b>Expiration date</b>
						<p>{{ Opp.Expiration | moment("MM/DD/YYYY") }}</p>
					</div>
					<div class="breathe-sm">
						<b>Description</b>
						<p>{{ Opp.Description }}</p>
					</div>
					<div class="breathe-sm">
						<b>How to apply</b>
						<p>{{ Opp.Instructions }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-card-foot">
			<b-button class="is-primary" :loading="submitting" :disabled="submitting" @click="submitOpportunity">Submit</b-button>
			<b-button class="is-grey" :disabled="submitting" @click="$parent.close()">Edit</b-button>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	export default {
		props: {
			Opp: Object
		},
		data() {
			return {
				submitting: false,
				opp: {}
			}
		},
		created() {
			this.Opp.Expiration = new Date(this.Opp.Expiration);
			this.Opp.PostDate = new Date(this.Opp.PostDate);
		},
		methods: {
			openBadNotification(message) {
				this.$buefy.notification.open({
					duration: 4000,
					message: message,
					type: 'is-danger',
				});
			},
			submitOpportunity() {
				this.opp = this.Opp;
				this.opp.Functions = this.opp.FunctionsSelect.join(" | ");

				this.opp.Industries = this.opp.IndustriesSelect.join(" | ");

				this.opp.Countries = this.opp.CountriesSelect.join(" | ");

				if (!this.opp.Link.startsWith("mailTo://")) {
					this.opp.Link = "mailTo://" + this.opp.Link;
				}

				this.submitting = true;
				this.$http.post("api/opportunity", this.opp)
					.then(resp => {
						if (resp.data.message.includes("Failed")) {
							if (this.opp.Id) {
								this.openBadNotification("Could not update opportunity.");
							}
							else {
								this.openBadNotification("Could not create opportunity.");
							}
							this.$parent.close();
						}
						else {
							if (this.opp.Id) {
								this.$buefy.toast.open({ message: "Successfully updated opportunity.", type: "is-success" })
							}
							else {
								this.opp.Id = resp.data.Id;
								this.$buefy.toast.open({ message: "Successfully created opportunity.", type: "is-success" })
							}
							this.$emit('saved', this.opp);
							this.$parent.close();
						}
						this.submitting = false;
					}).catch(err => {
						this.submitting = false;
						console.log(err);
					})
			},
		}
	}
</script>
